import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import TipsAndTricksItem from '../TipsAndTricksItem';

interface AdviceResponse {
  content: Record<string, { title: string; content: string }>;
}

interface Props {
  content: string[];
  adviceResponseObject: AdviceResponse;
  hasTitle?: boolean;
}

const TipsAndTricksNew = ({ content, adviceResponseObject, hasTitle = true }: Props) => {
  if (!content || !content.length) return null;

  return (
    <div className="lg:bg-main-light lg:px-5 pb-4 lg:rounded-[20px] mt-0">
      {hasTitle && (
        <>
          <p className="text-2xl font-bold lg:text-xl">Tips & tricks</p>
          <p className="text-sm mt-1 lg:text-lg lg:mt-2.5">
            Naast producten ook nog wat handige tips & tricks
          </p>
        </>
      )}
      {content.map((itemIndex) => {
        const item = adviceResponseObject.content[itemIndex];
        if (item) return <TipsAndTricksItem key={uuidv4()} item={item} />;
      })}
    </div>
  );
};

export default TipsAndTricksNew;
